import { useLayoutEffect } from 'react'

import { useIsAnalyticsAllowed } from 'hooks/useIsAnalyticsAllowed'

const GOOGLE_TAG_MANAGER_URL = 'https://www.googletagmanager.com/gtag/js'

export const GtagScript = () => {
  const isAllowed = useIsAnalyticsAllowed()

  useLayoutEffect(() => {
    if (isAllowed) {
      // Google is very specific about appending this script to the <head>, it doesn't work otherwise.
      // https://developers.google.com/analytics/devguides/collection/ga4#install_a_new_tag
      // We do not use the-platform's Script since it's appended to the <body>.
      const script = document.createElement('script')
      script.async = true
      script.src = GOOGLE_TAG_MANAGER_URL
      document.head.appendChild(script)
    }

    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() { window.dataLayer.push(arguments) }
    window.gtag('js', new Date())
  }, [isAllowed])

  return null
}
